import React, { useEffect } from 'react'
import AccountTemplate from 'components/templates/AccountTemplate'

export default props => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <AccountTemplate
      title={i18n.t('server.account.signup.title')}
      description={i18n.t('server.account.signup.description')}
      bodyClassName="body-home__index"
      {...props}
    >
      <div className="page__even lp-page__padding">
        <div className="page__col1">
          <div className="signup-head">
            <h1 className="page-title">ご登録メールアドレスの確認</h1>
          </div>
          <div className="signup-box">
            <div className="row">
              <div className="col-xs-12">
                <div className="signup-box__wrapper">
                  <p className="signup-box__notes ta-c">
                    スペースマーケットにご登録いただきまして、誠にありがとうございます！
                    <br />
                    ご登録いただいたメールアドレスに確認メールを送信しました。
                  </p>
                  <p className="signup-box__notes ta-c mt15">
                    アカウント登録を完了するには24時間以内にメールに記載のリンクを
                    <br className="sm-hide" />
                    クリックしアカウントを承認してください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AccountTemplate>
  )
}
